import { Attachment } from "../../../domain/model/Attachment";
import { Message } from "../../../domain/model/Auth";
import { Package } from "../../../domain/model/Package";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { PackageRepository } from "./PackageRepository";

export class PackageRepositoryImpl implements PackageRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getPackages(): Promise<Response<Array<Package>>> {
    return this.apiService.getPackages();
  }
}
